import React from 'react';
import Alert from 'components/Alert';
import PaymentPurposeDropdown, { PurposeOption }
  from 'components/Molecules/Payments/CreatePaymentDrawer/PaymentPurposeDropdown/PaymentPurposeDropdown';
import t from 'utils/translationHelper';

import { PaymentPurposeDto } from '@alpha/payments-dtos';
import { Box } from '@alpha/ui-lib/ui/external';
import { Input } from '@alpha/ui-lib/ui/Input';
import { Loader } from '@alpha/ui-lib/ui/Loader';
import { Typography } from '@alpha/ui-lib/ui/Typography';

import useStyles from './PurposeOfPayments.styles';

interface PurposeOfPaymentsProps {
  paymentPurposes?: PaymentPurposeDto[];
  canBeFreeText?: boolean;
  required?: boolean;
  selectValue?: string;
  handleDropdownChange?: (event: any, value: PurposeOption) => void;
  handleChange?: (event: any, value: string) => void;
  error?: string;
  loading?: boolean;
}

const PurposeOfPayments = ({
  paymentPurposes,
  canBeFreeText,
  required,
  selectValue,
  handleDropdownChange,
  handleChange,
  error,
  loading,
}: PurposeOfPaymentsProps) => {
  const styles = useStyles();

  if (required === false) {
    return <></>;
  }

  return (
    <Box marginTop="20px">
      <div style={{
        marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '8px',
      }}
      >
        <Typography variant="subtitle1" className="label">
          {t('purpose_of_payment')}
        </Typography>
        {!canBeFreeText ? (
          <PaymentPurposeDropdown
            data={paymentPurposes || []}
            handleChange={handleDropdownChange}
            placeholderText={t('please_select_a_purpose_of_payment')}
            data-testid="purpose"
            selectName="purpose"
            selectValue={selectValue}
          />
        ) : (
          <Input
            onChange={handleChange}
            fullWidth
            id="purpose"
            variant="filled"
            value={selectValue}
            testId="purposeOfPayment-input"
            helperText={error}
            error={!!error}
          />
        )}
      </div>
      <div style={{ marginBottom: '20px', marginTop: '20px', display: loading ? 'block' : 'none' }}>
        <Loader
          testId="purposeOfPayments-loader"
        />
      </div>
      {required && !selectValue && (
      <div style={{ width: '100%' }}>
        <Alert
          className={styles.info}
          variant="info"
          text={t('purpose_of_payment_is_required')}
        />
      </div>
      )}
    </Box>
  );
};

export default PurposeOfPayments;
